export const meta = {
  slug: { de: "knieschmerzen-was-tun", en: "knee-pain-what-to-do" },
  title: "Knieschmerzen: erste Schritte und wann ein Termin sinnvoll ist",
  excerpt:
    "Knieschmerzen entstehen oft schleichend und werden lange ausgehalten. Eine ruhige Einordnung hilft, den richtigen Zeitpunkt für einen Termin zu erkennen.",
  category: "patienten",
  publishedAt: "2026-04-17",
  metaTitle: "Knieschmerzen – wann ein Termin sinnvoll ist | OnePractix",
  metaDescription:
    "Welche Knieschmerzen sich beobachten lassen und wann ein zeitnaher Arzttermin sinnvoll ist – klare Einordnung und Hinweise zur Terminanfrage.",
  related: ["rueckenschmerzen-wann-zum-arzt", "orthopaede-termin-schnell"],
  en: {
    title: "Knee pain: first steps and when an appointment makes sense",
    metaTitle: "Knee pain – what to do and when to see a doctor | OnePractix",
    metaDescription:
      "Which knee complaints can be observed and when a timely doctor's appointment makes sense — calm guidance and notes for the request.",
    excerpt:
      "Knee pain often develops slowly and is endured for a long time. A calm assessment helps to recognise the right moment for an appointment.",
  },
};

export default meta;
